var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._g(_vm._b({attrs:{"items":_vm.items,"label":_vm.label,"dense":_vm.dense,"outlined":""},model:{value:(_vm.local),callback:function ($$v) {_vm.local=$$v},expression:"local"}},'v-select',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }